import React from 'react';

import MaterialTab from '../components/materialTab';
import {
    Typography,

} from "@material-ui/core"

import Menu from '../components/menu';
import Carusel from '../components/carusel';
import caruselBilder from "../css/image/aktuelles/carusel";
import { Helmet } from 'react-helmet';

const tabContents = [

    {
        title: "Termine & Veranstaltungen ",
        content: <div className="p-3 text-secondary">
            <h3>Termine & Veranstaltungen</h3>
            <div className="row m-0">

                <p className="col-12 m-0 mt-4 mb-2">
                    <b>Schließungszeiten integrative Kindertagesstätte 2026:</b>
                </p>
                <p className="col-12 col-md-6 m-0 mt-1">Brückentag nach Himmelfahrt</p>
                <p className="col-12 col-md-6 m-0 mt-1">15.05.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Sommerferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">20.07.2026 – 07.08.2026</p>

                <p className="col-12 m-0 mt-4 mb-2">
                    <b>Schließungszeiten Heilpädagogischer Kindergarten 2026:</b>
                </p>
                <p className="col-12 col-md-6 m-0 mt-1">Brückentag nach Himmelfahrt</p>
                <p className="col-12 col-md-6 m-0 mt-1">15.05.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Sommerferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">20.07.2026 – 07.08.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Herbstferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">12.10.2026 – 16.10.2026</p>

                <p className="col-12 m-0 mt-4 mb-2">
                    <b>Schließungszeiten Schule am Waldkater anerk. Tagesbildungsstätte 2026:</b>
                </p>
                <p className="col-12 col-md-6 m-0 mt-1">Brückentag nach Himmelfahrt</p>
                <p className="col-12 col-md-6 m-0 mt-1">15.05.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Sommerferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">15.07.2026 – 04.08.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Herbstferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">12.10.2026 – 16.10.2026</p>

                <p className="col-12 m-0 mt-4 mb-2">
                    <b>Betriebsurlaubszeiten Werkstätten für behinderte Menschen der PLSW für das Jahr 2026:</b>
                </p>
                <p className="col-12 col-md-6 m-0 mt-1">Brückentag nach Himmelfahrt</p>
                <p className="col-12 col-md-6 m-0 mt-1">15.05.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Sommerferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">20.07.2026 – 31.07.2026</p>
                <p className="col-12 col-md-6 m-0 mt-1">Winterferien</p>
                <p className="col-12 col-md-6 m-0 mt-1">24.12.2026 – 31.12.2026</p>

            </div>
        </div>
    },
    //{
    //    title: "Projekte",
    //    content: <div className="p-3 text-secondary ">
    //        <h3>Projekte </h3>
    //        <div className="row m-0">
    //            <div className="col-12 col-md-6">
    //                <h5> Assistenz beim Wohnen</h5>
    //                <p>
    //                    Die Räumlichkeiten der Assistenz beim Wohnen werden aufgrund kontinuierlicher Klientenzahl (zur Zeit 40) ins Haus Katharina verlegt und erweitert.
    //                    Zur Zeit finden dort Renovierungsarbeiten statt – es entsteht ein neuer Treffpunkt für gemeinsame Aktivitäten mit Küche, Aufenthaltsräumen und Sanitäranlagen.
    //                </p>
    //            </div>
    //            <div className="col-12 col-md-6">
    //
    //                <h5>Erweiterung integrative Kita</h5>
    //                <p>
    //                    Planung und Bau einer zusätzlichen Krippengruppe mit ca. 15 Plätzen. Der Baustart ist geplant für Sommer 2021, Fertigstellung im Frühjahr 2022.
    //                    {/*  Planung und Bau einer zusätzlichen Krippengruppe Der Baustart ist geplant für
    //                    Sommer 2021. Dort wo jetzt Lagerräume angesiedelt sind, entsteht ein ganz neuer
    //                    moderner Kindergarten, in dem ca. 18 Kinder zukünftig ihren Kita-Alltag erleben
    //                    dürfen. In diesen neu geschaffenen Räumlichkeiten wird die Integrationsgruppe
    //                    einziehen. Dadurch können wir eine weitere Krippengruppe mit ca. 15 Plätzen
    //                    anbieten. */}
    //                </p>
    //            </div>
    //
    //
    //        </div>
    //    </div>
    //},
    /*  {
         title: "Besuchszeiten",
         content: <div className="p-3 text-secondary ">
             <h3>Besuchszeiten </h3>
             <div>
                 <h5> Zurzeit gelten noch unsere Corona Besuchszeiten:</h5>
                 <ul>
                     <li>Letzter Einlass im Pflegebereich Haus am Waldkater 17:30 Uhr</li>
                 </ul>
                 <p>
                     Nach Wegfall der Corona Einschränkung möchten wir generell wieder auf
                     reglementierte Besuchszeiten verzichten.
                 </p>
             </div>
         </div>
     }, */
    /*   {
          title: "Schule am Waldkater",
          content: <div className="p-3 text-secondary ">
              <h3>Schule am Waldkater</h3>
              <div className="row">
                  <div className="col-12 col-md-6 m-auto">
                      <img src={Bild_SchuleAmWaltkater} alt="" width="100%" height="300px" className="cover rounded" />
                      <p className="mt-2"><small><i>
                          v.l. Melvin Maximilian John, Karina Olschewski, Kevin Jablonski
                      </i> </small></p>
                  </div>
                  <div className="col-12 col-md-6 mt-2">
                      <h5>Schulentlassungsfeier in der Schule am Waldkater, Rinteln. e.V.</h5>
                      <p className="small">
                          Am 13. Juli 2022 feierten Kevin Jablonski und Melvin Maximilian John ihre Entlassungsfeier.
                          Beide haben ihre Schulzeit absolviert und wurden von der Leitung der Schule,
                          Frau Karina Olschewski, im Rahmen einer kleinen Feierlichkeit in die „Arbeitswelt“ entlassen.
                          <br /><br />
                          Die Schulabsolventen erhielten Abschiedsgeschenke von den Mitarbeiterinnen der Abschlussstufe,
                          sowie von den MitschülerInnen und der Schulleiterin. Frau Olschewski überreichte den
                          Schulabgängern eine Mappe mit den jeweiligen Abschlusszeugnissen und einem kurzen Überblick
                          über<br />
                          die vergangenen Jahre. Melvin wurden bereits in der Frühförderung und im Heilpädagogischen
                          Kindergarten der Lebenshilfe Rinteln e.V. betreut. Er wechselte zwischenzeitlich in andere
                          Einrichtungen, kam jedoch zurück nach Rinteln und besuchte die Schule am Waldkater (anerk.
                          Tagesbildungsstätte). Kevin besuchte die Frühförderung, den Heilpädagogischen Kindergarten und
                          die Schule am Waldkater (anerk. Tagesbildungsstätte) der Lebenshilfe Rinteln e.V.
                          <br /><br />
                          Somit haben Beide den Großteil ihres Lebens in der Lebenshilfe Rinteln e.V. verbracht, es ist ein
                          Zuhause geworden. Demnach verließen die Schüler die Einrichtung mit einem „weinenden“ und
                          einem
                          „lachenden“ Auge.
                          Das Kollegium und die Schülerschaft wünschen Beiden alles Gute für die Zukunft.
                      </p>
                  </div>
              </div>
  
  
          </div>
      } */
]


class Aktuelles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        window.scrollTo(0, 0)
        return (<>
            <Helmet>
                {/* Grundlegende Meta-Tags */}
                <meta charSet="utf-8" />
                <title>Aktuelles – Lebenshilfe Rinteln</title>
                <meta
                    name="description"
                    content="Bleiben Sie informiert über Neuigkeiten, Veranstaltungen und aktuelle Entwicklungen bei der Lebenshilfe Rinteln."
                />
                <meta
                    name="keywords"
                    content="Lebenshilfe Rinteln, Aktuelles, Neuigkeiten, Veranstaltungen, Termine, News, Informationen"
                />
                <meta name="author" content="Lebenshilfe Rinteln" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

                {/* Canonical Link */}
                <link rel="canonical" href="https://www.lebenshilfe-rinteln.de/aktuelles" />

                {/* Optional: Open Graph für bessere Darstellung bei Facebook & Co */}
                <meta property="og:title" content="Aktuelles – Lebenshilfe Rinteln" />
                <meta
                    property="og:description"
                    content="Neuigkeiten, Termine und aktuelle Informationen rund um die Lebenshilfe Rinteln."
                />
                <meta property="og:url" content="https://www.lebenshilfe-rinteln.de/aktuelles" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Lebenshilfe Rinteln" />

                {/* Optional: Twitter Cards */}
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Aktuelles – Lebenshilfe Rinteln" />
                <meta
                    name="twitter:description"
                    content="Alle Neuigkeiten und Termine der Lebenshilfe Rinteln auf einen Blick."
                />
            </Helmet>




            <div style={{ marginTop: "100px" }} className="animate__animated animate__fadeIn">

                {this.props.mobileVersion ? "" : <Menu {...this.props} />}
                <>
                    <div className="container text-center shadow-sm p-0 rounded">
                        <h3 className="p-2 text-info bg-white m-0">Aktuelle Informationen</h3>
                        <Carusel bilder={caruselBilder()} height="400px" width="100%" className="rounded shadow-sm" />
                    </div>
                </>


                <div className="mt-4 bg-white shadow-sm rounded mb-4 p-3 border-info container shadow" style={{ borderRight: "8px", borderRightStyle: "solid" }}>
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 p-2 text-center">
                            <img
                                src="/assets/zari/1.jpg"
                                alt="ZARi – Zentrum für Autismus Rinteln"
                                className="img-fluid rounded"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "400px",
                                    objectFit: "cover",
                                }}
                            />
                        </div>

                        <div className="col-12 col-md-6 d-flex flex-column">
                            <Typography
                                className="text-center mt-3 mt-md-auto ff-3"
                                variant="h5"
                                component="h2"
                                gutterBottom
                                sx={{ fontWeight: 600, color: "primary.main" }}
                            >
                                ZARi jetzt auch im Kreis Lippe
                            </Typography>

                            <Typography
                                variant="body1"
                                paragraph
                                className="text-secondary text-justify mb-auto"
                                sx={{ pr: { md: 3 } }}
                            >
                                Liebe Familien,
                                <br /><br />
                                Wir freuen uns Ihnen mitteilen zu können, dass das ZARi nun für Kinder
                                und Jugendliche mit Wohnort im <strong>Kreis Lippe</strong> neben{" "}
                                <strong>Porta Westfalica</strong> ebenfalls seine Türen eröffnen kann.
                                <br /><br />
                                Sie möchten uns kennenlernen und ein Bild von unserem Angebot erhalten?
                                <br />
                                Melden Sie sich zeitnah telefonisch, um eine unverbindliche Erstberatung
                                zu erhalten.
                                <br /><br />
                                Wir freuen uns auf Sie!
                            </Typography>
                        </div>
                    </div>
                </div>




                <div className="mt-4 bg-white shadow-sm rounded mb-4 p-3 border-lila container shadow" style={{ borderRight: "8px", borderRightStyle: "solid" }}>
                    <div className="row align-items-center" >
                        <div className="col-12 col-md-6 p-2 text-center">
                            <img
                                src="/assets/aktuelles/1.jpeg"
                                alt="Marte Meo Zertifizierung"
                                className="img-fluid rounded"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "400px",
                                    objectFit: "cover",
                                }}
                            />
                        </div>

                        <div className="col-12 col-md-6 d-flex flex-column">
                            <Typography
                                className="text-center mt-3 mt-md-auto ff-3"
                                variant="h5"
                                component="h2"
                                gutterBottom
                                sx={{ fontWeight: 600, color: "primary.main" }}
                            >
                                Wir sind Marte Meo zertifiziert!
                            </Typography>

                            <Typography
                                variant="body1"
                                paragraph
                                className="text-secondary text-justify mb-auto"
                                sx={{ pr: { md: 3 } }}
                            >
                                Am 13. September durften wir uns als Frühförderung auf dem Marte Meo
                                Fachtag von Maria Aarts auszeichnen lassen.

                                Nun sind wir eine <strong>Marte Meo Institution</strong> und freuen uns
                                sehr, die Methode als eine unserer Stützen in unserer Arbeit zu
                                bezeichnen.

                                Unser Team besteht aus <strong>Marte Meo Practitionern</strong>,{" "}
                                <strong>Therapists</strong> sowie einer <strong>Supervisorin</strong>.

                                Wenn Sie mehr über die Marte Meo Methode oder unsere Frühförderarbeit
                                erfahren möchten, sprechen Sie uns gerne jederzeit an!
                            </Typography>
                        </div>
                    </div>
                </div>




                <>
                    <div className={"mt-4 bg-white shadow-sm rounded mb-4 p-3 container"}>
                        <MaterialTab tabs={tabContents} {...this.props} />
                    </div>
                </>

            </div>
        </>
        );
    }
}

export default Aktuelles;